import { RawCheckbox } from '@festina-life/ui/forms'

type Props = {
  label: string
  paths: string[]
  isChecked: boolean
  onToggle: () => void
  id: string
}

export const SubTemplateCreationCheckbox = ({
  id,
  label,
  paths,
  isChecked,
  onToggle,
}: Props) => (
  <div className="flex flex-row gap-x-2">
    <RawCheckbox id={id} checked={isChecked} onChange={onToggle} />
    <div>
      <label htmlFor={id}>{label}</label>
      <div className="flex flex-col gap-y-2">
        <div className="text-sm opacity-50">
          {paths.map((path) => (
            <div key={path}>{path}</div>
          ))}
        </div>
      </div>
    </div>
  </div>
)
